 function getSelectedSku() {
    const variantInput = document.querySelector(
      '.shopify-section--main-product .product-info product-form input[name="id"]'
    );
    if (!variantInput) return null;

    const option = document.querySelector(`.allvariants-wrap option[value="${variantInput.value}"]`);

    return option ? option.dataset.sku : null;
  }

  let selectedSku = getSelectedSku();
  let isVTOOpen = false;
  let isColorSelected = false;

  const DEFAULT_PATTERNS = {
    'Crème over powder': '0',
    'Crème only': '2',
    'Powder only': '1',
    Rounded: '3',
    Diffused: '4',
    Lifted: '5',
    Undereye: '6',
  };

  /* SKUs that support patterns */
  const PATTERN_SKUS = [
    '4017',
    '4016',
    '4020',
    '4024',
    '4027',
    '4013',
    '4018',
    '4014',
    '4012',
    '4019',
    '4011',
    '4015',
    '4026',
    '4022',
    '4025',
    '4010',
    '4021',
    '4028',
    '4029',
    '4023',
    '4040',
  ];

  /* Generate pattern map */
  const PATTERN_DATA = {
    4017: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
    4016: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
    4020: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
    4024: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
    4027: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
    4013: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
    4018: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
    4014: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
    4012: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
    4019: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
    4011: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
    4015: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
    4026: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
    4022: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
    4025: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
    4010: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
    4021: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
    4028: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
    4029: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
    4023: {
      'Crème over powder': '0',
      'Crème only': '2',
      'Powder only': '1',
      Rounded: '3',
      Diffused: '4',
      Lifted: '5',
      Undereye: '6',
    },
  };
  PATTERN_SKUS.forEach((sku) => {
    PATTERN_DATA[sku] = DEFAULT_PATTERNS;
  });

  document.addEventListener('DOMContentLoaded', () => {
    const vtoBtn = document.getElementById('vto-btn');
    const ymkModuleWrap = document.getElementById('YMK-module-wrap');
    const patternBoxWrap = document.getElementById('pattern-selector-wrap');
    const patternBox = document.getElementById('pattern-selector');
    const ymkModule = document.getElementById('YMK-module');

    function applyVTO(sku, pattern = null) {
      if (!window.YMK || !sku) return;

      if (pattern) {
        YMK.applyMakeupBySku(sku, pattern);
      } else {
        YMK.applyMakeupBySku(sku);
      }
    }

    /* ---------- RENDER PATTERNS ---------- */
    function renderPatterns(sku) {
      if (!patternBox) return;

      patternBox.innerHTML = '';

      const patterns = PATTERN_DATA[sku];

      if (!patterns) {
        patternBoxWrap?.classList.add('hidden');
        return;
      }

      const heading = document.createElement('div');
      heading.className = 'pattern-heading';
      heading.textContent = 'Select Pattern';

      patternBox.appendChild(heading);

      Object.entries(patterns).forEach(([label, pattern]) => {
        const btn = document.createElement('button');
        btn.className = 'pattern-btn';
        btn.textContent = label;

        btn.addEventListener('click', () => {
          applyVTO(selectedSku, pattern);
        });

        patternBox.appendChild(btn);
      });

      const patternBtns = patternBox.querySelectorAll('.pattern-btn');

      heading.addEventListener('click', () => {
        heading.classList.toggle('active');

        patternBtns.forEach((btn) => {
          btn.classList.toggle('active');
        });
      });

      patternBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          heading.textContent = btn.textContent;
          heading.classList.remove('active');

          patternBtns.forEach((b) => b.classList.remove('active'));
        });
      });
    }

    /* ---------- YMK INIT ---------- */
    const isMobile = window.innerWidth <= 450;
    const vtoWidth = isMobile ? window.innerWidth - 80 : 480;
    const vtoHeight = isMobile ? Math.round(vtoWidth * 1.4) : 640;

    window.ymkAsyncInit = function () {
      if (!window.YMK) return;

      YMK.init({
        autoOpen: false,
        showCloseButton: false,
        width: vtoWidth,
        height: vtoHeight,
        hideButtonsOnResultsPage: true,
        privacyPolicyURL: 'https://patrickta.com/pages/privacy-policy',
      });
    };

    /* ---------- OPEN VTO ---------- */
    const chooser = document.getElementById('vto-chooser');
    const chooserMain = document.getElementById('vto-chooser-main');
    const chooserModels = document.getElementById('vto-chooser-models');
    const modelList = document.getElementById('vto-chooser-model-list');
    const photoInput = document.getElementById('vto-photo-input');
    let modelsLoaded = false;
    let pendingChooserHide = false;
    let chooserLoadingTimeout = null;

    /* YMK.open(loadLiveCam, file) — true jumps into live camera, a File jumps into photo try-on */
    function openYMK(loadLiveCam, file) {
      if (!window.YMK) return;

      isVTOOpen = true;
      /* The active shade's makeup is applied on open (applyVTO below), so the
         pattern panel must show for it too - gating on a later swatch change
         left "Select Pattern" missing until the shopper switched shades (BH #598). */
      selectedSku = getSelectedSku() || selectedSku;
      isColorSelected = !!selectedSku;

      /* Keep our screen (with spinner) until YMK renders — its own loader takes over from there */
      pendingChooserHide = true;
      chooser?.classList.add('vto-chooser--loading');
      clearTimeout(chooserLoadingTimeout);
      chooserLoadingTimeout = setTimeout(() => {
        pendingChooserHide = false;
        chooser?.classList.remove('vto-chooser--loading');
        chooser?.classList.add('hidden');
      }, 12000);

      ymkModuleWrap?.classList.remove('hidden');

      if (file) {
        YMK.open(false, file);
      } else {
        YMK.open(loadLiveCam === true);
      }

      applyVTO(selectedSku);

      setTimeout(() => {
        renderPatterns(selectedSku);
      }, 400);
    }

    function getYMKApiKey() {
      const s = document.querySelector('script[src*="makeupar.com"][src*="apiKey="]');
      return s ? new URL(s.src).searchParams.get('apiKey') : null;
    }

    /* Model photos come from the account's Perfect Corp module settings (same list the YMK launcher shows) */
    async function showModelPanel() {
      chooserMain?.classList.add('hidden');
      chooserModels?.classList.remove('hidden');

      if (modelsLoaded || !modelList) return;
      modelsLoaded = true;

      try {
        const res = await fetch(
          'https://plugins.makeupar.com/api/webconsultation/query-config.action?apiKey=' +
            getYMKApiKey() +
            '&version=v3&minorVersion='
        );
        const data = await res.json();

        /* Same list the YMK launcher renders: pages.model_list -> blocks.models.configs.models */
        const models = (data?.pages?.model_list?.panels?.body?.blocks?.models?.configs?.models || [])
          .filter((m) => m && m.imgSrc)
          .map((m) => ({ thumb: m.thumbnailSrc || m.imgSrc, full: m.imgSrc }));

        if (!models.length) throw new Error('no models');

        models.forEach((m, i) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'vto-chooser__model';
          btn.setAttribute('aria-label', 'Model ' + (i + 1));
          btn.innerHTML = '<img src="' + m.thumb + '" alt="" loading="lazy">';

          btn.addEventListener('click', async () => {
            const blob = await fetch(m.full).then((r) => r.blob());
            openYMK(false, new File([blob], 'model.jpg', { type: blob.type || 'image/jpeg' }));
          });

          modelList.appendChild(btn);
        });
      } catch (e) {
        openYMK(false); /* fallback: let YMK's own launcher handle it */
      }
    }

    vtoBtn?.addEventListener('click', () => {
      if (!window.YMK) return;

      chooser?.classList.remove('hidden');
      chooser?.classList.remove('vto-chooser--loading');
      pendingChooserHide = false;
      clearTimeout(chooserLoadingTimeout);
      chooserModels?.classList.add('hidden');
      chooserMain?.classList.remove('hidden');
      const gallery = document.querySelector('.shopify-section--main-product .product-gallery');

      gallery?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    });

    chooser?.querySelectorAll('[data-vto-mode]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const mode = btn.dataset.vtoMode;

        if (mode === 'live') openYMK(true);
        else if (mode === 'photo') photoInput?.click();
        else if (mode === 'model') showModelPanel();
      });
    });

    photoInput?.addEventListener('change', () => {
      const file = photoInput.files && photoInput.files[0];
      if (file) openYMK(false, file);
      photoInput.value = '';
    });

    document.getElementById('vto-chooser-back')?.addEventListener('click', () => {
      chooserModels?.classList.add('hidden');
      chooserMain?.classList.remove('hidden');
    });

    document.getElementById('vto-chooser-close')?.addEventListener('click', () => {
      chooser?.classList.add('hidden');
    });

    /* The SDK's close button is disabled (showCloseButton: false), so this is
       the only way out of the try-on. isVTOOpen must reset FIRST: the 300ms
       visibility interval re-shows the wrap whenever it is true. YMK.close()
       tears the module down and stops a live camera; reopening later goes
       through the normal chooser -> openYMK path again. */
    document.getElementById('vto-widget-close')?.addEventListener('click', () => {
      isVTOOpen = false;
      try {
        window.YMK?.close?.();
      } catch (e) {}
      ymkModuleWrap?.classList.add('hidden');
      patternBoxWrap?.classList.add('hidden');
      chooser?.classList.add('hidden');
    });

    document.addEventListener('variant:change', (e) => {
      const variant = e.detail.variant;
      if (!variant) return;

      /* Assign the OUTER selectedSku - a `const` here shadowed it, so pattern
         button clicks and the pattern-panel visibility check kept using the
         page-load shade after every swatch change (BH #598). */
      if (!variant.sku) return;
      selectedSku = variant.sku;
      isColorSelected = true;

      if (isVTOOpen && window.YMK?.isLoaded?.()) {
        applyVTO(selectedSku);
        renderPatterns(selectedSku);
      }
    });

    /* ---------- VISIBILITY CONTROL ---------- */
    /* While the SDK's camera-consent dialog is up it shows its OWN close (X)
       inside the module, and ours floats right next to it - two Xs at once
       (client report, Aug 27). The SDK iframe is same-origin, so: hide our
       close while their consent X is visible, and make dismissing consent
       tear the try-on down fully (declining the camera = leaving) instead of
       stranding an empty module. */
    const ourCloseBtn = document.getElementById('vto-widget-close');
    function syncConsentClose() {
      let consentClose = null;
      try {
        consentClose = ymkModule?.querySelector('iframe')?.contentDocument?.getElementById('consent-close') || null;
      } catch (e) { /* cross-origin variant of the SDK - nothing to coordinate */ }

      const consentShowing = !!(consentClose && consentClose.getBoundingClientRect().width > 0);
      /* Inline style, not the .hidden utility - the button's own display:flex
         rule outranks the utility class. */
      if (ourCloseBtn) ourCloseBtn.style.display = consentShowing ? 'none' : '';

      if (consentClose && !consentClose.dataset.ptExitBound) {
        consentClose.dataset.ptExitBound = '1';
        consentClose.addEventListener('click', () => {
          document.getElementById('vto-widget-close')?.click();
        });
      }
    }

    setInterval(() => {
      if (!isVTOOpen) return;
      syncConsentClose();

      const isYMKEmpty = !ymkModule || ymkModule.innerHTML.trim() === '';

      if (isYMKEmpty) {
        patternBoxWrap?.classList.add('hidden');
        ymkModuleWrap?.classList.add('hidden');
        return;
      }

      ymkModuleWrap?.classList.remove('hidden');

      /* YMK UI is in — hand off from our chooser to its loader */
      if (pendingChooserHide) {
        pendingChooserHide = false;
        clearTimeout(chooserLoadingTimeout);
        chooser?.classList.remove('vto-chooser--loading');
        chooser?.classList.add('hidden');
      }

      if (PATTERN_DATA[selectedSku] && isColorSelected) {
        patternBoxWrap?.classList.remove('hidden');
      } else {
        patternBoxWrap?.classList.add('hidden');
      }
    }, 300);
  });